import React, { useEffect, useState } from 'react';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import './slider.scss';

interface IWPSliderProps {
    min?: number;
    max?: number;
    value: any;
    range: boolean;
    onChange: (value: number | number[]) => void;
}

const IWPSlider = (props: IWPSliderProps) => {
    const [year, setYear] = useState<number | number[]>(props.value);

    const handleAfterChange = (value: number | number[]) => {
        if (props.onChange) {
            props.onChange(value);
        }
    };

    const handleChange = (value: number | number[]) => {
        setYear(value);
    };

    useEffect(() => {
        setYear(props.value);
    }, [props.value]);

    return (
        <div className="iwpslider">
            <label className="chartfilter-label">{props.range ? 'Zeitraum' : 'Jahr'}</label>
            <div className="iwpslider-slider">
                <div className="iwpslider-mark">{props.min}</div>
                <div className="iwpslider-wrapper">
                    <Slider
                        range={props.range}
                        min={props.min}
                        max={props.max}
                        onChange={handleChange}
                        onAfterChange={handleAfterChange}
                        value={year}
                    />
                </div>
                <div className="iwpslider-mark">{props.max}</div>
            </div>
        </div>
    );
};

export default IWPSlider;
